<div class="sivu">
  <details class="ohje-details">
    <summary class="ohje-summary">Mitä testiajo tekee?</summary>
    <div class="ohje-sisalto">
      <p class="ohje-kappale">
        Jokaiselle setin tositteelle lähetetään valitulle Gemini- tai Claude-mallille (Google Agent Platform, EU) tositteen viimeisimmän version kaikki kuvat (tai ladattu tiedosto) sekä
        testitapaukseen tallennettu toimittajarekisterin snapshot. Tuotannon tositteen luku käyttää edelleen Geminiä.
      </p>
      <p class="ohje-kappale">Claude ei tue HEIC-kuvia, joten niitä sisältävät tositteet merkitään Claude-ajoissa virheellisiksi ilman mallikutsua.</p>
      <p class="ohje-kappale">
        Mallin vastaus pisteytetään käsin syötettyjä metatietoja vasten: toimittajan nimi normalisoituna (kirjainkoko, välimerkit, välilyönnit ja yhtiömuoto eivät vaikuta), y-tunnus/VAT niin että
        suomalainen y-tunnus ja FI-VAT ovat sama tunnus, tunnuksen tyyppi syötetyn muodon mukaan, päivämäärä tarkasti ja summa sentin tarkkuudella. Odotettu toimittaja-avain johdetaan
        rekisterisnapshotista tunnuksella tai nimellä. Null molemmin puolin on osuma.
      </p>
      <p class="ohje-kappale">
        Vain kentät joilla on odotusarvo arvioidaan: päivämäärä ja summa vain jos syötetty, toimittaja-avain vain lemonaid-tositteille joilla on rekisteri. Prosentit lasketaan arvioiduista
        riveistä; "kaikki oikein" vaatii jokaisen arvioidun kentän osuman. Harmaa arvo = ei arvioitu.
      </p>
      <p class="ohje-kappale">
        Putki valitsee, mitä tositteen lukua testataan. Lemonatorin luku on kirjausehdotuksen toimittajan tunnistuksen luku sellaisenaan. Webin ja mobiilin luvussa mallia kutsutaan samalla
        promptilla ja vastauksen rakenteella kuin tuotannossa, ja mallille kerrotaan testitapauksen viitepäivä "tänään"-päivänä. Testiajo pisteyttää mallin vastauksen; summa verrataan
        itseisarvona, koska prompti pyytää hyvityksenkin positiivisena. Gemini-mallit kutsutaan tuotannon koodilla. Claude-mallit saavat saman promptin, syötteen ja vastauksen rakenteen, mutta
        niiden kutsu on penkin oma. Output-tokeneihin lasketaan molemmilla malleilla myös ajattelu.
      </p>
      <p class="ohje-kappale">
        Valmiin webin ja mobiilin testiajon päälle voi ajaa jälkikäsittelyn. Se käsittelee testiajon mallin vastaukset samalla koodilla kuin tuotanto ja pisteyttää lopulliset arvot omaksi
        ajokseen (odotettu → raaka ⇒ lopullinen). Mallia ei kutsuta. Lopullinen summa verrataan etumerkillisenä, tunnuksen tyyppiä ei arvioida, ja ostolaskuksi merkityn testitapauksen odotettu
        päivämäärä on viitepäivä.
      </p>
    </div>
  </details>

  <div class="kontrollirivi">
    <mat-form-field class="setti-kentta">
      <mat-label>Setti</mat-label>
      <mat-select [formField]="settiKentta">
        @for (s of setit(); track s.avain) {
          <mat-option [value]="s.avain">{{ s.nimi }} ({{ s.testitapausLkm }} kpl)</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="kapea-kentta">
      <mat-label>Putki</mat-label>
      <mat-select [formField]="putkiKentta">
        @for (putki of putket; track putki) {
          <mat-option [value]="putki">{{ putkenNimi[putki] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="kapea-kentta">
      <mat-label>Malli</mat-label>
      <mat-select [formField]="malliKentta">
        @for (m of mallit; track m) {
          <mat-option [value]="m">{{ m }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="kapea-kentta">
      <mat-label>Promptin versio</mat-label>
      <mat-select [formField]="promptVersioKentta">
        <mat-option [value]="uusinPrompt">Uusin</mat-option>
        @for (p of promptVersiot(); track p.versio) {
          <mat-option [value]="p.versio">v{{ p.versio }} — {{ p.paivitetty | date: 'dd.MM.yyyy HH:mm' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-primary-button (click)="aloitaTestiAjo()" [disabled]="!settiKentta().value() || kaynnistetaan()" class="aloita-nappi" actionId="Aloita tositteen luvun testiajo">
      @if (kaynnistetaan()) {
        <mat-spinner diameter="18" class="nappi-spinner"></mat-spinner>
      }
      Aloita testiajo
    </app-primary-button>
  </div>

  <div class="suodatinrivi">
    <mat-form-field class="suodatin-kentta" subscriptSizing="dynamic">
      <mat-label>Näytä ajot setistä</mat-label>
      <mat-select [formField]="suodatusKentta">
        <mat-option [value]="kaikkiSetit">Kaikki setit</mat-option>
        @for (s of setit(); track s.avain) {
          <mat-option [value]="s.avain">{{ s.nimi }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (ajotLataa()) {
    <mat-spinner diameter="32"></mat-spinner>
  } @else if (!ajot().length) {
    <p class="tyhja-viesti">Ei testiajoja.</p>
  } @else {
    <mat-accordion>
      @for (ajo of ajot(); track ajo.avain) {
        <mat-expansion-panel (opened)="onAjoPaneelAuki(ajo)" (closed)="onAjoPaneelKiinni(ajo.avain)">
          <mat-expansion-panel-header class="ajon-otsikkorivi" collapsedHeight="auto" expandedHeight="auto">
            <mat-panel-title class="paneelin-otsikko">
              @if (ajo.tila === 'kaynnissa') {
                <mat-spinner diameter="16"></mat-spinner>
              }
              @if (ajo.tila === 'valmis') {
                <mat-icon class="tila-ikoni-ok">check_circle</mat-icon>
              }
              @if (ajo.tila === 'virhe') {
                <mat-icon class="tila-ikoni-virhe">cancel</mat-icon>
              }
              <span class="ajon-perustiedot">{{ ajo.aloitettu | date: 'dd.MM.yyyy HH:mm' }} — {{ ajo.malli }} — prompt v{{ ajo.promptVersio }}</span>
              <span class="setti-nimi-merkki">{{ putkenNimi[ajo.putki] }}</span>
              @if (ajo.laji === 'jalkikasittely') {
                <span class="setti-nimi-merkki">Jälkikäsittely{{ lahdeajonAloitus(ajo) ? ' ajosta ' + (lahdeajonAloitus(ajo) | date: 'dd.MM.yyyy HH:mm') : '' }}</span>
              }
              @if (ajo.testisettiAvain) {
                <span class="setti-nimi-merkki">Setti: {{ ajo.testisettiNimi }}</span>
              } @else {
                <span class="setti-poistettu-merkki" matTooltip="Setti on poistettu">setti: {{ ajo.testisettiNimi }} (poistettu)</span>
              }
            </mat-panel-title>
            @if (ajo.tila === 'kaynnissa') {
              <mat-panel-description> {{ kasiteltyLkm().get(ajo.avain) ?? 0 }} / {{ ajo.tositteita }} käsitelty </mat-panel-description>
            }
            @if (ajo.tila === 'valmis') {
              <mat-panel-description>
                {{ ajo.tositteita }} kpl &nbsp;|&nbsp; Summa {{ ajo.tarkkuusProsentit.summa !== null ? (ajo.tarkkuusProsentit.summa | number: '1.1-1') + '%' : '—' }} &nbsp;|&nbsp; Toimittaja-avain
                {{ ajo.tarkkuusProsentit.toimittajaAvain !== null ? (ajo.tarkkuusProsentit.toimittajaAvain | number: '1.1-1') + '%' : '—' }} &nbsp;|&nbsp; Täydelliset
                {{ taydellisetProsentti(ajo) !== null ? (taydellisetProsentti(ajo) | number: '1.1-1') + '%' : '—' }}
              </mat-panel-description>
            }
          </mat-expansion-panel-header>

          @if (ajo.tila === 'kaynnissa') {
            <div class="kaynnissa-lohko">
              <p class="kaynnissa-teksti">Testiajo on käynnissä...</p>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }

          @if (ajo.tila === 'virhe') {
            <div class="virhe-lohko">
              <div class="virhe-otsikko">Testiajo päättyi virheeseen</div>
              @if (ajo.virheViesti) {
                <pre class="virhe-viesti">{{ ajo.virheViesti }}</pre>
              }
            </div>
          }

          @if (ajo.tila === 'valmis') {
            <table class="yhteenveto-taulukko">
              <tr>
                <td class="yhteenveto-solu">Käsitelty:</td>
                <td>
                  <strong>{{ ajo.tositteita }}</strong>
                </td>
                <td class="yhteenveto-solu--valissa">{{ ajo.laji === 'jalkikasittely' ? 'Onnistuneita jälkikäsittelyjä:' : 'Onnistuneita mallikutsuja:' }}</td>
                <td>
                  <strong>{{ ajo.onnistuneita }}</strong>
                </td>
              </tr>
              @for (kentta of kentatAjolle(ajo); track kentta) {
                <tr>
                  <td class="yhteenveto-solu">{{ kenttaOtsikot[kentta] }}:</td>
                  <td>
                    <strong>{{ ajo.tarkkuusProsentit[kentta] !== null ? (ajo.tarkkuusProsentit[kentta] | number: '1.1-1') + '%' : '—' }}</strong>
                  </td>
                </tr>
              }
              <tr>
                <td class="yhteenveto-solu">Täydelliset osumat:</td>
                <td>
                  <strong>{{ ajo.taydellisetOsumat }}</strong>
                </td>
                <td class="yhteenveto-solu--valissa">Tokenit (in/out):</td>
                <td>
                  <strong>{{ ajo.yhteensaInputTokenit }} / {{ ajo.yhteensaOutputTokenit }}</strong>
                </td>
              </tr>
            </table>
          }

          @if (ajo.tila === 'valmis' && ajo.putki === 'lemonaid' && ajo.laji === 'testiajo') {
            <div class="jalkikasittely-lohko">
              <app-button (click)="ajaJalkikasittely(ajo)" [disabled]="jalkikasitellaan().has(ajo.avain)" matIcon="tune" actionId="Aja tositteen luvun jälkikäsittely" [actionContext]="[ajo.avain]">
                @if (jalkikasitellaan().has(ajo.avain)) {
                  <mat-spinner diameter="18" class="nappi-spinner"></mat-spinner>
                }
                Aja jälkikäsittely
              </app-button>
            </div>
          }

          <div class="prompti-lohko">
            <app-button (click)="togglePrompt(ajo.avain)" styles="padding-left: 0" [matIcon]="naytaPromptAvaimet().has(ajo.avain) ? 'expand_less' : 'expand_more'" actionId="Näytä/piilota tositteen luvun ajon prompti">
              {{ naytaPromptAvaimet().has(ajo.avain) ? 'Piilota prompti' : 'Näytä prompti (snapshot v' + ajo.promptVersio + ')' }}
            </app-button>
            @if (naytaPromptAvaimet().has(ajo.avain)) {
              <pre class="prompti-sisalto">{{ ajo.prompt }}</pre>
            }
          </div>

          @if (tuloksetAjoAvain() === ajo.avain) {
            @if (tuloksetLataa()) {
              <mat-spinner diameter="24"></mat-spinner>
            } @else if (tulokset().length) {
              <div class="tulokset-scroll">
                <table class="tulokset-taulukko">
                  <tr class="tulokset-otsikkorivi">
                    <th class="tulokset-th">Tosite</th>
                    @for (kentta of kentatAjolle(ajo); track kentta) {
                      <th class="tulokset-th">
                        {{ kenttaOtsikot[kentta] }}<br /><span class="tulokset-th-alaotsikko">{{ ajo.laji === 'jalkikasittely' ? 'odotettu → raaka ⇒ lopullinen' : 'odotettu → luettu' }}</span>
                      </th>
                    }
                    <th class="tulokset-th">Kaikki oikein</th>
                    <th class="tulokset-th--virhe">Virhe</th>
                  </tr>
                  @for (t of tulokset(); track t.avain) {
                    <tr class="tulokset-rivi" (click)="toggleTulos(t)">
                      <td class="tulokset-solu">{{ t.nimi }}</td>
                      @for (kentta of kentatAjolle(ajo); track kentta) {
                        @if (ajo.laji === 'jalkikasittely') {
                          <td class="tulokset-solu">
                            @if (t.osumat[kentta] === null) {
                              <span class="ei-arvioitu" matTooltip="Kenttää ei arvioitu tälle tositteelle">ei arvioitu</span>
                            } @else {
                              {{ arvoTekstiksi(t, kentta, 'odotetut') }}
                            }
                            → <span [style.color]="lahteenOsumanVari(t, kentta)">{{ arvoTekstiksi(t, kentta, 'lahde') }}</span> ⇒
                            <span [style.color]="osumanVari(t, kentta)">{{ arvoTekstiksi(t, kentta, 'luetut') }}</span>
                          </td>
                        } @else {
                          <td class="tulokset-solu" [style.color]="osumanVari(t, kentta)">
                            @if (t.osumat[kentta] === null) {
                              <span matTooltip="Kenttää ei arvioitu tälle tositteelle">ei arvioitu → {{ arvoTekstiksi(t, kentta, 'luetut') }}</span>
                            } @else {
                              {{ arvoTekstiksi(t, kentta, 'odotetut') }} → {{ arvoTekstiksi(t, kentta, 'luetut') }}
                            }
                          </td>
                        }
                      }
                      <td class="tulokset-solu">
                        @if (kaikkiOikein(t, ajo)) {
                          <span class="kaikki-oikein-kylla">Kyllä</span>
                        } @else {
                          <span class="kaikki-oikein-ei">Ei</span>
                        }
                      </td>
                      <td class="tulokset-virhe-solu">{{ t.virhe }}</td>
                    </tr>
                    @if (avattuTulosAvain() === t.avain) {
                      <tr>
                        <td [attr.colspan]="kentatAjolle(ajo).length + 3" class="raakavastaus-rivi">
                          <div class="raakavastaus-otsikko">Mallin raaka vastaus (tokenit {{ t.inputTokenit }} / {{ t.outputTokenit }})</div>
                          @if (raakaVastaustaLadataan() && t.raakaVastaus === undefined) {
                            <mat-spinner diameter="20"></mat-spinner>
                          } @else {
                            <pre class="raakavastaus-sisalto">{{ t.raakaVastaus ?? '—' }}</pre>
                          }
                        </td>
                      </tr>
                    }
                  }
                </table>
              </div>
            } @else {
              <p class="ei-tuloksia">Ei tuloksia.</p>
            }
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
